import Vue from 'vue'
import _ from 'lodash'

const state = {
    student: {},
    showQrCodeModal: false,
};

const actions = {
    hide({ commit }) {
        commit('setStudent', {});
        commit('setShowQrCodeModal', false);
    },
};

const mutations = {
    setStudent(state, student) {
        Vue.set(state, 'student', _.cloneDeep(student));
    },
    setShowQrCodeModal(state, showQrCodeModal) {
        state.showQrCodeModal = showQrCodeModal;
    },
};

const getters = {
    student(state) {
        return state.student;
    },
    showQrCodeModal(state) {
        return state.showQrCodeModal;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};